import { DEFAULT_COLOR_VTV_PALETTE_COLORS as e } from "./index.es59.js";
const o = {
  year: "2023"
}, t = {
  additionalStyleFont: "Open Sans",
  additionalStyleFontWeight: "400",
  additionalStyleSize: "12",
  additionalStyleFontColor: "#FFFFFF",
  additionalStyleFontColorOpacity: 100,
  vtvPalette: e[0],
  roadLabelType: "CPD",
  roadLabelCustomText: "",
  vtvOpacity: 100,
  bgFillColorOpacity: 80,
  dropShadowColorOpacity: 80,
  bgFillColor: "#2F3C44",
  dropShadowColor: "#2F3C44",
  dropShadowHardness: "2",
  bgCornerRadius: 12,
  showRoadLabelNames: !0,
  roadLabelShowLabelsFor: 3,
  bgStroke: !1,
  bgEnabled: !0,
  vtvEnabled: !0,
  dropShadowEnabled: !0,
  roadLabelEnable: !0,
  inEditMode: !0,
  includeLayer: !0,
  legendTitle: "Cars Per Day",
  items: [],
  roadType: [1, 2, 3, 4, 5],
  userInputRange: [0, 1],
  minTrafficRange: 0,
  maxTrafficRange: 1,
  histogram: [],
  userAddedFeatures: {},
  userRemovedFeatures: {},
  userLockedFeatures: {},
  roadLabelDisplay: {},
  offsetMap: {},
  tempRoadLabelId: ""
};
export {
  t as vehicleTrafficVolumeDefaultVisualFilter,
  o as vehicleTrafficVolumeNewInrixDefaultFetchFilter
};
//# sourceMappingURL=index.es99.js.map
